import axios from "axios";
import React, { useEffect, useState, createContext } from "react";

const ConfigureContext = createContext({
  logo: "",
  cognitoId: "",
  appClientId: "",
  setConfig: () => {},
});

export const ConfigureProvider = ({ children }) => {
  const [config, setConfig] = useState(() => {
    // Initialize from localStorage if available
    const savedConfig = localStorage.getItem("appConfig");
    return savedConfig
      ? JSON.parse(savedConfig)
      : { logo: "", cognitoId: "", appClientId: "" };
  });

  useEffect(() => {
  if (config.cognitoId && config.appClientId) return;

  let domain = window.location.hostname;
  domain =
    domain === "localhost" ? process.env.REACT_APP_METADATA_DOMAIN : domain;

  axios
    .get(
      `${process.env.REACT_APP_BACK_END_API_BASE_URL}/configuration/getMetaData?vendorDomain=${domain}`
    )
    .then((res) => {
      const newConfig = {
        logo: res.data.logo,
        cognitoId: res.data.userPoolId,
        appClientId: res.data.appClientId,
        icon: res.data.icon,
      };
      setConfig(newConfig);
      localStorage.setItem("appConfig", JSON.stringify(newConfig));
    })
    .catch((err) => {
      console.error("Failed to fetch metadata:", err);
    });
}, [config]);

  return (
    <ConfigureContext.Provider value={{ ...config, setConfig }}>
      {children}
    </ConfigureContext.Provider>
  );
};

export default ConfigureContext;
